import {
  ProgressBar as AriaProgressBar,
  ProgressBarProps as AriaProgressBarProps,
} from 'react-aria-components';
import { composeTailwindRenderProps, numToPercentage } from 'src/utils';

interface ProgressBarProps extends AriaProgressBarProps {
  showTooltip?: boolean;
}

const ProgressBar = ({
  showTooltip = true,
  className,
  ...props
}: ProgressBarProps) => {
  return (
    <AriaProgressBar
      {...props}
      className={composeTailwindRenderProps(
        className,
        `flex flex-col gap-1 min-w-32 ${showTooltip ? 'mb-7' : ''}`
      )}
    >
      {({ percentage, isIndeterminate }) => (
        <div
          className={`w-full h-1 rounded-full bg-surface-ghost outline outline-1 -outline-offset-1 outline-transparent relative ${isIndeterminate ? 'overflow-hidden' : ''}`}
        >
          <div
            className={`absolute top-0 h-full rounded-full bg-secondary ${isIndeterminate ? 'left-full animate-in duration-1000 [--tw-enter-translate-x:calc(-16rem-100%)] slide-out-to-right-full repeat-infinite ease-out' : 'left-0'}`}
            style={{ width: `${isIndeterminate ? 40 : percentage}%` }}
          />
          {!isIndeterminate && showTooltip && (
            <span
              className="absolute top-full bg-secondary rounded px-1 py-0.5 text-xs font-semibold text-secondary-75 -translate-x-full mt-1.5"
              style={{ left: `${percentage}%` }}
            >
              <svg
                width="9"
                height="9"
                viewBox="0 0 9 9"
                fill="none"
                className="absolute right-0 bottom-full translate-y-1/2 text-secondary"
              >
                <path d="M0 9L8.99996 0L9 9H0Z" fill="currentColor" />
              </svg>
              {numToPercentage(Number(percentage))}
            </span>
          )}
        </div>
      )}
    </AriaProgressBar>
  );
};

export default ProgressBar;
